import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import LoadTop from "../components/Common/ScrollTop/LoadTop";

const PageLoader = () => (
  <div className="d-flex justify-content-center align-items-center vh-100 vw-100 bg-white">
    <div className="page-loader"></div>
    <style>{`
      .page-loader {
        width: 64px;
        height: 64px;
        position: relative;
        background-image: linear-gradient(#0735a6 16px, transparent 0),
          linear-gradient(#ed701f 16px, transparent 0),
          linear-gradient(#ed701f 16px, transparent 0),
          linear-gradient(#0735a6 16px, transparent 0);
        background-repeat: no-repeat;
        background-size: 16px 16px;
        background-position: left top, left bottom, right top, right bottom;
        animation: rotate 1s linear infinite;
      }

      @keyframes rotate {
        0% {
          width: 64px;
          height: 64px;
          transform: rotate(0deg);
        }
        50% {
          width: 30px;
          height: 30px;
          transform: rotate(180deg);
        }
        100% {
          width: 64px;
          height: 64px;
          transform: rotate(360deg);
        }
      }
    `}</style>
  </div>
);

// Lazy load all page components for better performance
const Home = lazy(() => import("../pages/home"));
const HomeTwo = lazy(() => import("../pages/home-2"));
const HomeThree = lazy(() => import("../pages/home-3"));
const HomeFour = lazy(() => import("../pages/home-4"));
const HomeFive = lazy(() => import("../pages/home-5"));
const HomeSix = lazy(() => import("../pages/home-6"));
const HomeSeven = lazy(() => import("../pages/home-7"));
const HomeEight = lazy(() => import("../pages/home-8"));
const HomeNine = lazy(() => import("../pages/home-9"));
const HomeTen = lazy(() => import("../pages/home-10"));
const HomeEleven = lazy(() => import("../pages/home-11"));
const HomeTwelve = lazy(() => import("../pages/home-12"));
const HomeThirteen = lazy(() => import("../pages/home-13"));
const HomeOnePage = lazy(() => import("../pages/onepage-1"));
const HomeTwoOnePage = lazy(() => import("../pages/onepage-2"));
const HomeThreeOnePage = lazy(() => import("../pages/onepage-3"));
const HomeFourOnePage = lazy(() => import("../pages/onepage-4"));
const HomeFiveOnePage = lazy(() => import("../pages/onepage-5"));
const HomeSixOnePage = lazy(() => import("../pages/onepage-6"));
const HomeSevenOnePage = lazy(() => import("../pages/onepage-7"));
const HomeEightOnePage = lazy(() => import("../pages/onepage-8"));
const HomeNineOnePage = lazy(() => import("../pages/onepage-9"));
const HomeTenOnePage = lazy(() => import("../pages/onepage-10"));
const HomeElevenOnePage = lazy(() => import("../pages/onepage-11"));
const HomeTwelveOnePage = lazy(() => import("../pages/onepage-12"));
const HomeThirteenOnePage = lazy(() => import("../pages/onepage-13"));
const About = lazy(() => import("../pages/about"));
const Team = lazy(() => import("../pages/team"));
const TeamDetails = lazy(() => import("../pages/team/team-details"));
const Blog = lazy(() => import("../pages/blog"));
const BlogDetails = lazy(() => import("../pages/blog/blog-details"));
const Services = lazy(() => import("../pages/service"));
const ServiceOne = lazy(() => import("../pages/service/service-1"));
const ServiceTwo = lazy(() => import("../pages/service/service-2"));
const ServiceThree = lazy(() => import("../pages/service/service-3"));
const ServiceDetails = lazy(() => import("../pages/service/service-details"));
const SoftwareDevelopment = lazy(() =>
  import("../pages/service/software-development")
);
const WebDevelopment = lazy(() => import("../pages/service/web-development"));
const AnalyticSolutions = lazy(() =>
  import("../pages/service/analytic-solutions")
);
const CloudAndDevops = lazy(() => import("../pages/service/cloud-and-devops"));
const ProjectDesign = lazy(() => import("../pages/service/project-design"));
const DataCenter = lazy(() => import("../pages/service/data-center"));
const CaseStudtyStyleOne = lazy(() => import("../pages/case-study/style-1"));
const CaseStudtyStyleTwo = lazy(() => import("../pages/case-study/style-2"));
const CaseStudtyStyleThree = lazy(() => import("../pages/case-study/style-3"));
const CaseStudtyStyleFour = lazy(() => import("../pages/case-study/style-4"));
const CaseStudtyStyleFive = lazy(() => import("../pages/case-study/style-5"));
const CaseStudtyStyleSix = lazy(() => import("../pages/case-study/style-6"));
const CaseStudtyStyleSeven = lazy(() => import("../pages/case-study/style-7"));
const Shop = lazy(() => import("../pages/shop"));
const ShopSingle = lazy(() => import("../pages/shop/shop-single"));
const Cart = lazy(() => import("../pages/shop/cart"));
const Checkout = lazy(() => import("../pages/shop/checkout"));
const MyAccount = lazy(() => import("../pages/shop/my-account"));
const Faq = lazy(() => import("../pages/faq"));
const Pricing = lazy(() => import("../pages/pricing"));
const Contact = lazy(() => import("../pages/contact"));
const Error = lazy(() => import("../pages/404"));

const App = () => {
  return (
    <div className="App">
      <LoadTop />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/home-2" element={<HomeTwo />} />
          <Route path="/home-3" element={<HomeThree />} />
          <Route path="/home-4" element={<HomeFour />} />
          <Route path="/home-5" element={<HomeFive />} />
          <Route path="/home-6" element={<HomeSix />} />
          <Route path="/home-7" element={<HomeSeven />} />
          <Route path="/home-8" element={<HomeEight />} />
          <Route path="/home-9" element={<HomeNine />} />
          <Route path="/home-10" element={<HomeTen />} />
          <Route path="/home-11" element={<HomeEleven />} />
          <Route path="/home-12" element={<HomeTwelve />} />
          <Route path="/home-13" element={<HomeThirteen />} />
          <Route path="/onepage-1" element={<HomeOnePage />} />
          <Route path="/onepage-2" element={<HomeTwoOnePage />} />
          <Route path="/onepage-3" element={<HomeThreeOnePage />} />
          <Route path="/onepage-4" element={<HomeFourOnePage />} />
          <Route path="/onepage-5" element={<HomeFiveOnePage />} />
          <Route path="/onepage-6" element={<HomeSixOnePage />} />
          <Route path="/onepage-7" element={<HomeSevenOnePage />} />
          <Route path="/onepage-8" element={<HomeEightOnePage />} />
          <Route path="/onepage-9" element={<HomeNineOnePage />} />
          <Route path="/onepage-10" element={<HomeTenOnePage />} />
          <Route path="/onepage-11" element={<HomeElevenOnePage />} />
          <Route path="/onepage-12" element={<HomeTwelveOnePage />} />
          <Route path="/onepage-13" element={<HomeThirteenOnePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/service" element={<Services />} />
          <Route path="/service/service-1" element={<ServiceOne />} />
          <Route path="/service/service-2" element={<ServiceTwo />} />
          <Route path="/service/service-3" element={<ServiceThree />} />
          <Route path="/service/service-details" element={<ServiceDetails />} />
          <Route
            path="/service/software-development"
            element={<SoftwareDevelopment />}
          />
          <Route path="/service/web-development" element={<WebDevelopment />} />
          <Route
            path="/service/analytic-solutions"
            element={<AnalyticSolutions />}
          />
          <Route
            path="/service/cloud-and-devops"
            element={<CloudAndDevops />}
          />
          <Route path="/service/project-design" element={<ProjectDesign />} />
          <Route path="/service/data-center" element={<DataCenter />} />
          <Route path="/team" element={<Team />} />
          <Route path="/team/team-details" element={<TeamDetails />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/blog-details" element={<BlogDetails />} />
          <Route path="/case-study/style-1" element={<CaseStudtyStyleOne />} />
          <Route path="/case-study/style-2" element={<CaseStudtyStyleTwo />} />
          <Route
            path="/case-study/style-3"
            element={<CaseStudtyStyleThree />}
          />
          <Route path="/case-study/style-4" element={<CaseStudtyStyleFour />} />
          <Route path="/case-study/style-5" element={<CaseStudtyStyleFive />} />
          <Route path="/case-study/style-6" element={<CaseStudtyStyleSix />} />
          <Route
            path="/case-study/style-7"
            element={<CaseStudtyStyleSeven />}
          />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/shop-single" element={<ShopSingle />} />
          <Route path="/shop/cart" element={<Cart />} />
          <Route path="/shop/checkout" element={<Checkout />} />
          <Route path="/shop/my-account" element={<MyAccount />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </Suspense>
    </div>
  );
};

export default App;
